<template>
    <div class="row">
        <div class="col-lg-3">
            <Multiselect
                v-model="getCategory"
                :options="categoryList"
                mode="tags"
                :can-clear=true
                :searchable="true"
                :placeholder="this.$t('product_search_category') + ' (' + this.categoryList.length + ')'"
                @select="filterSelected()"
                @close="filterSelected()"
            />
        </div>
        <div class="col-lg-3">
            <Multiselect
                v-model="getBrand"
                :options="brandList"
                mode="tags"
                :can-clear=true
                :searchable="true"
                :placeholder="this.$t('product_search_brand') + ' (' + this.brandList.length + ')'"
                @select="filterSelected()"
                @close="filterSelected()"
            />
        </div>
        <div class="col-lg-3">
            <Multiselect
                v-model="getSize"
                :options="sizeList"
                mode="tags"
                :can-clear=true
                :searchable="true"
                :placeholder="this.$t('product_search_size') + ' (' + this.sizeList.length + ')'"
                @select="filterSelected()"
                @close="filterSelected()"
            />
        </div>
        <div class="col-lg-3">
            <Multiselect
                v-model="getSizeDetails"
                :options="sizeDetailsList"
                mode="tags"
                :can-clear=true
                :searchable="true"
                :placeholder="this.$t('product_search_size_detail') + ' (' + this.sizeDetailsList.length + ')'"
                @select="filterSelected()"
                @close="filterSelected()"
            />
        </div>
    </div>
</template>
<script>
import Multiselect from "@vueform/multiselect";

export default {
    props:{
        mainData:{
            type: Array,
            required: true
        },
    },
    components: {
        Multiselect
    },
    data(){
        return{
            // filter bar
            brandList: [],
            getBrand: [],
            getCategory: [],
            categoryList: [],
            sizeList: [],
            getSize: [],
            sizeDetailsList: [],
            getSizeDetails: [],

            mainCategoryList: [],
            backendData: [],
        }
    },
    methods:{
        async getFilterData(){
            await this.$mainApi.get('api/product/filter/')
                .then(response => {
                    if(response.data.status === 80){
                        console.log(response.data.details)
                        // 1 -> Category, 2 -> Brand
                        this.backendData = response.data.details
                        this.categoryList = response.data.details[0]["1"]
                        this.brandList = response.data.details[1]["2"]
                        this.sizeList = response.data.details[2]["3"]
                        this.sizeDetailsList = response.data.details[3]["4"]
                        this.mainCategoryList = response.data.details[7]["8"]
                    }
                })
        },
        returnIDListByValueName(dataList, selectedList){
            let copy = dataList
            let returnIDList = []
            for(let i of selectedList){
                for(let ii of copy){
                    if(i === ii.value){
                        returnIDList.push(ii.id)
                    }
                }
            }
            return returnIDList
        },
        getRealSizeDetail(getInputList){
            let copy = this.sizeDetailsList
            let returnList = []
            for(let i of getInputList){
                for(let ii of copy){
                    if(i === ii.value){
                        returnList.push(ii.size_detail)
                    }
                }
            }
            return returnList
        },
        filterSelected(){
            let nowTableData = this.mainData

            if(this.getCategory.length > 0 && this.getBrand.length > 0 && this.getSize.length > 0 && this.getSizeDetails.length > 0 ){
                nowTableData = nowTableData.filter(a =>
                    this.getCategory.includes(a.category_name) &&
                    this.getBrand.includes(a.brand_name) &&
                    this.getSize.includes(a.size_group) &&
                    this.getRealSizeDetail(this.getSizeDetails).includes(a.size_detail)
                )
            }
            if(this.getCategory.length > 0 ){
                nowTableData = nowTableData.filter(a => this.getCategory.includes(a.category_name))
            }
            if(this.getBrand.length > 0 ){
                nowTableData = nowTableData.filter(a => this.getBrand.includes(a.brand_name))
            }
            if(this.getSize.length > 0 ){
                nowTableData = nowTableData.filter(a => this.getSize.includes(a.size_group))
            }
            if(this.getSizeDetails.length > 0 ){
                nowTableData = nowTableData.filter(a => this.getRealSizeDetail(this.getSizeDetails).includes(a.size_detail))
            }
            this.$emit('getFilteredData', nowTableData)
        },
    },
    async mounted() {
        await this.getFilterData()
    }
}

</script>
<style scoped>

</style>